module.exports = __webpack_public_path__ + "3fd0e9ec2c1fad2103766ef501beb509.svg";